if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      
      // Get target end time from data attribute (default: 12am/midnight)
      this.targetHour = parseInt(this.dataset.targetHour || '0');
      this.targetMinute = parseInt(this.dataset.targetMinute || '0');
    }

    getNextTargetTime() {
      const now = new Date();
      const target = new Date();
      
      // Set target time to specified hour:minute
      target.setHours(this.targetHour, this.targetMinute, 0, 0);
      
      // If target time has passed today, set it to tomorrow
      if (now >= target) {
        target.setDate(target.getDate() + 1);
      }
      
      return target.getTime();
    }

    connectedCallback() {
      let _this = this;
      
      // Set initial countdown target
      this.countDownDate = this.getNextTargetTime();

      const updateTime = function () {
        // Get current time
        const now = new Date().getTime();

        // Find the distance between now and the countdown date
        const distance = _this.countDownDate - now;

        // Time calculations for hours, minutes and seconds
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Get display elements
        let hoursBlock = _this.querySelector(".hours .countdown-timer__date-header");
        let minutesBlock = _this.querySelector(".minutes .countdown-timer__date-header");
        let secondsBlock = _this.querySelector(".seconds .countdown-timer__date-header");

        if (distance < 0) {
          // Timer reached 0, reset for next day
          _this.countDownDate = _this.getNextTargetTime();
          requestAnimationFrame(updateTime);
        } else {
          // Update display
          if (hoursBlock) hoursBlock.innerHTML = CountdownTimer.addZero(hours);
          if (minutesBlock) minutesBlock.innerHTML = CountdownTimer.addZero(minutes);
          if (secondsBlock) secondsBlock.innerHTML = CountdownTimer.addZero(seconds);

          _this.classList.remove("loading-effect");
          requestAnimationFrame(updateTime);
        }
      };
      
      requestAnimationFrame(updateTime);
    }

    static addZero(x) {
      return x < 10 && x >= 0 ? "0" + x : x;
    }
  }
  
  customElements.define("countdown-timer", CountdownTimer);
}